import { useMemo } from 'react';
import { ExpandCollapseToggleProps } from './types';

export const useExpandCollapseToggle = (props: ExpandCollapseToggleProps) => {
  const { expandedSections, visibleSections, onExpandAll, onCollapseAll } =
    props;

  // Determine if all sections are expanded
  const areAllExpanded = useMemo(() => {
    if (visibleSections.length === 0) return false;
    return visibleSections.every(section => expandedSections.has(section.id));
  }, [expandedSections, visibleSections]);

  // Handle toggle click
  const handleToggleClick = (): void => {
    if (areAllExpanded) {
      onCollapseAll();
    } else {
      onExpandAll();
    }
  };

  return {
    areAllExpanded,
    handleToggleClick,
  };
};
